import React from 'react'

function termsandconditions() {
    return (
        <div>
            <center> <div style={{ textAlign: "center",fontWeight:700,fontSize:"30px" }}>Termsandconditions</div></center>
            <div>
                <p>
                    It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
                    The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using &#39;Content here, content here&#39;,
                    making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text,
                    and a search for &#39;lorem ipsum&#39; will uncover many web sites still in their infancy.
                    Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
                </p>
            </div>
        </div>
    )
}

export default termsandconditions